import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ThemeProvider from "./theme/ThemeProvider";
import SnackbarProvider from "./ui/SnackbarProvider";
import SyncJobProvider from "./ui/SyncJobProvider";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardPage from "./pages/DashboardPage";
import DashboardDetailPage from "./pages/DashboardDetailPage";
import ConnectorsPage from "./pages/ConnectorsPage";
import ConnectorDetailPage from "./pages/ConnectorDetailPage";
import DataRelationshipsPage from "./pages/DataRelationshipsPage";
import EntityDetailPage from "./pages/EntityDetailPage";
import CopilotPage from "./pages/copilot/CopilotPage";
import CopilotHomePage from "./pages/copilot/CopilotHomePage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import AISettingsPage from "./pages/settings/AISettingsPage";
import WorkspaceSettingsPage from "./pages/settings/WorkspaceSettingsPage";
import BrandingSettingsPage from "./pages/settings/BrandingSettingsPage";
import AccountSettingsPage from "./pages/settings/AccountSettingsPage";
import SpacesPage from "./pages/SpacesPage";
import SpaceDetailPage from "./pages/SpaceDetailPage";
import UsersPage from "./pages/UsersPage";
import OnboardingWizard from "./pages/onboarding/OnboardingWizard";
import DataSyncPage from "./pages/DataSyncPage";
import DataSyncJobPage from "./pages/DataSyncJobPage";

function App() {
  // Defer PostHog init past FCP — posthog-js queues events until init() is called,
  // so no analytics are lost. The dynamic import keeps the SDK out of the critical chunk.
  React.useEffect(() => {
    import('./posthog');
  }, []);

  return (
      <ThemeProvider>
        <SnackbarProvider>
          <SyncJobProvider>
          <Router>
          <Routes>
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<OnboardingWizard />} />
            <Route path="/login-pwd" element={<LoginPage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            {/* Post-OTP setup (path choice, sample data, etc.) - same wizard, URL synced in OnboardingWizard */}
            <Route path="/onboarding/*" element={<OnboardingWizard />} />
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<CopilotHomePage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="dashboard/:dashboardId" element={<DashboardDetailPage />} />
              <Route path="spaces" element={<SpacesPage />} />
              <Route path="spaces/:spaceId" element={<SpaceDetailPage />} />
              <Route path="saved-queries" element={<SpacesPage />} /> {/* Backwards compatibility */}
              <Route path="connectors" element={<ConnectorsPage />} />
              <Route path="connectors/:connectorId" element={<ConnectorDetailPage />} />
              <Route path="data-sync" element={<DataSyncPage />} />
              <Route path="data-sync/:jobId" element={<DataSyncJobPage />} />
              <Route path="data-model" element={<DataRelationshipsPage />} />
              <Route path="data-model/entity/:entityName" element={<EntityDetailPage />} />
              <Route path="knowledge" element={<KnowledgeBasePage />} />
              {/* Settings — split by audience and concern. */}
              <Route path="settings/ai" element={<AISettingsPage />} />
              <Route path="settings/workspace" element={<WorkspaceSettingsPage />} />
              <Route path="settings/branding" element={<BrandingSettingsPage />} />
              <Route path="settings/account" element={<AccountSettingsPage />} />
              {/* Backwards compatibility — redirect old flat routes to the new IA. */}
              <Route path="settings" element={<Navigate to="/settings/ai" replace />} />
              <Route path="settings/organization" element={<Navigate to="/settings/account" replace />} />
              <Route path="branding" element={<Navigate to="/settings/branding" replace />} />
              <Route path="profile" element={<Navigate to="/settings/account" replace />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="copilot" element={<CopilotHomePage />} />
              <Route path="copilot/:threadId" element={<CopilotPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/copilot" replace />} />
          </Routes>
        </Router>
          </SyncJobProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
